import React, { useEffect, useState } from 'react';

import i18next from "i18next";
import { EntityService, TimeFormattingService } from "../../services";
import { DataTypeDisplayValue } from '../DataTypeDisplayValue';
import EntityImageGallery from "./entity_image_gallery";
import './embedded-entity-detail.scss';

const HEALTH_ONLY_DEVICE_DATA_TYPES = ['lqi', 'rssi', 'lora_snr', 'lora_dr', 'lora_freq', 'battery', 'cell_rssi', 'cell_rsrp', 'cell_sinr', 'cell_rsrq', 'battery_percentage'];
const FULL_EXLUCDE_DEVICE_DATA_TYPES = ["lqi", "rssi", "lora_snr", "lora_dr", "lora_freq", "cell_rssi", "cell_rsrp", "cell_sinr", "cell_rsrq"];

const EmbeddedEntityDetail = ({ serialNumber, healthOnlyDisplay }) => {
  const [entity, setEntity] = useState(null);

  useEffect(() => {
    EntityService.getBySerialNumber(serialNumber)
        .then((response) => {
          setEntity(response.entity)
        })
        .catch((error) => {
          console.log(error);
        });
  }, [serialNumber]);

    if (entity) {
      const measurements = healthOnlyDisplay ?
        entity.currentMeasurements?.filter((measurement) => HEALTH_ONLY_DEVICE_DATA_TYPES.includes(measurement.originatingDeviceDataTypeToken)) :
        entity.currentMeasurements?.filter((measurement) => !FULL_EXLUCDE_DEVICE_DATA_TYPES.includes(measurement.originatingDeviceDataTypeToken));

      return (<EmbeddedEntityArea healthOnlyDisplay={healthOnlyDisplay} entity={entity} measurements={measurements} />);
    } else {
      return (
          <div className="embedded-device-detail">
              <div className="loader">{i18next.t("pages.maps.loading")}</div>
          </div>
      );
    }
};

const EmbeddedEntityArea = ({healthOnlyDisplay, entity, measurements}) => (
  <div className="embedded-device-detail">
    <div className="embedded-device-detail__heading">
      <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-category">
        <label>{ i18next.t('pages.maps.device-type') }</label>
        <p>{entity.entityTypeName}</p>
      </div>
      <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-status">
        <label>{ i18next.t('pages.maps.device-status') }</label>
        <p>{ i18next.t(`device-statuses.${entity.statusToken}`) } / {entity.online ? "Online" : "Offline"}</p>
      </div>
      <div className="card-data-side-info">
        <div className="card-data-cell remove-border-left">
          <label>{ i18next.t('pages.maps.last-updated-at') }:</label>
          <p>{TimeFormattingService.renderFromNowTime(entity.lastUpdatedAt, entity.businessGroup?.timezone)}</p>
        </div>
      </div>
    </div>
    {
      measurements.length > 0 &&
      <div className="embedded-device-detail__data">
        <h4>{healthOnlyDisplay ? 'Last Received Health Data' : 'Last Received Data'}</h4>
        <table className="table">
          <thead>
          <tr>
            <th>{ i18next.t('pages.maps.device-name') }</th>
            <th>{ i18next.t('pages.maps.current-value') }</th>
            <th>{ i18next.t('pages.maps.last-updated-at') }</th>
          </tr>
          </thead>
          <tbody>
          {
            measurements
              .filter((measurement) => measurement.endTime === null)
              .map((measurement) => (
              <tr key={measurement.originatingDeviceDataTypeToken}>
                <td>
                  { 
                    entity.entityTypeToken === 'asset' ? measurement.originatingMeasureName : i18next.t(`device-data-types.${measurement.originatingDeviceDataTypeToken}`) 
                  }
                </td>
                <td>
                  <DataTypeDisplayValue 
                    value={measurement.lastReceivedData} 
                    deviceTypeToken={entity.primaryDeviceTypeToken}                     
                  />
                </td>
                <td>
                  {measurement.lastReceivedData
                      ? TimeFormattingService.renderFromNowTime(measurement.lastReceivedData.lastUpdatedAt, entity.businessGroup?.timezone)
                      : i18next.t('unknown')}
                </td>
              </tr>
            ))
          }
          </tbody>
        </table>
      </div>
    }
    { 
      entity.images?.length > 0 &&
      <div className="device-detail-overlay">
        <div className="embedded-device-detail__data image-header">
          <label style = {{color: "#1f627b",fontSize: "16px", borderBottom: "1px solid rgb(216, 215, 215)"}}>{ i18next.t('pages.devices.images') }</label>
          <EntityImageGallery serialNumber={entity.serialNumber} images={entity.images ?? []} hideZoom={true} />
        </div>
      </div>
    }
  </div>
);

export default EmbeddedEntityDetail;
